import { Component, Input, ViewChild, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, NgForm } from '@angular/forms';
import { MatPaginator, MatSort, MatTableDataSource, MatDialogRef, MatDialog } from '@angular/material';
import * as XLSX from 'xlsx';
import { AuthProvider } from '../../providers/auth/auth';
import { DatabaseProvider } from '../../providers/database/database';
import _ from 'lodash';
import { BehaviorSubject, Subject } from 'rxjs';
import { AlertController, ToastController, LoadingController } from 'ionic-angular';
import { UtilityProvider } from '../../providers/utility/utility';
import { PatientProvider } from '../../providers/patient/patient';
import { PdfProvider } from '../../providers/pdf/pdf';
import { DocumentProcessDialogComponent } from '../../components/document-process-dialog/document-process-dialog';
import { PdfProviderFR } from '../../providers/pdf/pdfFR';

@Component({
  selector: 'patient-document',
  templateUrl: 'patient-document.html'
})
export class PatientDocumentComponent implements OnInit {
  private ngUnsubscribe: Subject<any> = new Subject();
  program_id: string;
  program_name: string;
  patient: any;
  exportjson: any;
  custom_text = false;
  custom_text_hint = null;
  private _program_id = new BehaviorSubject<any>([]);
  private _program_name = new BehaviorSubject<any>([]);
  private _patient = new BehaviorSubject<any>([]);

  @Input()
  set programId(value) { this._program_id.next(value); }
  get programId() { return this._program_id.getValue(); }

  @Input()
  set programName(value) { this._program_name.next(value); }
  get programName() { return this._program_name.getValue(); }

  @Input()
  set patientData(value) { this._patient.next(value); }
  get patientData() { return this._patient.getValue(); }

  chartDialogRef: MatDialogRef<DocumentProcessDialogComponent>;

  userid: string;
  user_fullname: string;
  user: any;
  case_manager: string;
  cms: any[] = [];
  language = 'English';
  letter_type: string;
  letter_customtext: string;
  documentPanelStatus = false;

  addeditForm: FormGroup; 

  displayedColumns = ['type', 'desc', 'ext', 'created',  'createdby', 'updated', 'updatedby','actions'];
  dataSource: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('formDirective') private formDirective: NgForm;

  constructor(
    private readonly auth: AuthProvider,
    private dbPatient: PatientProvider,
    private db: DatabaseProvider,
    public alertCtrl: AlertController,
    public utility: UtilityProvider,
    private pdf: PdfProvider,
    private pdfFR: PdfProviderFR,
    public toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    public matDialog: MatDialog
    ) {
      this.auth.getCurrentUser().then(user => {
        this.userid = user.id;
        this.user_fullname = user.first_name + ' ' + user.last_name;
        this.user = { id: user.id, name: user.first_name + ' ' + user.last_name };

        this.dbPatient
        .listDocuments(this.program_id, this.patient.id)
        .snapshotChanges()
        .map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            data.id = a.payload.doc.id;
            return data;
          });
        })
        .takeUntil(this.ngUnsubscribe)
        .subscribe(documents => {
          this.exportjson = documents;
          this.dataSource = new MatTableDataSource(documents);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        });

        this.db
        .getUsers()
        .snapshotChanges()
        .map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            data.id = a.payload.doc.id;
            return data;
          });
        })
        .takeUntil(this.ngUnsubscribe)
        .subscribe((users) => {
          this.cms = _.filter(users, user => (user.roles.navigator_ncm || user.roles.navigator_rcm) && user.program_id === this.program_id);
          this.case_manager = this.user_fullname;
        });
      });
    }

  ngOnInit()  {
    this._program_id
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
        this.program_id = x
    });

    this._program_name
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
        this.program_name = x
    });

    this._patient
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
        this.patient = x
    });
  }

  ngOnDestroy() {
    console.log('Leave patient documents and destroy subscriptions');
    this._patient.unsubscribe();
    this._program_id.unsubscribe();
    this._program_name.unsubscribe();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  isDisabled()  {
    if (this.patient.therapy && this.patient.indication && this.patient.doctor) {
      return false;
    } else {
      return true;
    }
  }

  export() {
    const workBook = XLSX.utils.book_new(); // create a new blank book
    const workSheet = XLSX.utils.json_to_sheet(this.exportjson);

    XLSX.utils.book_append_sheet(workBook, workSheet, 'Documents'); // add the worksheet to the book
    XLSX.writeFile(workBook, 'documents.xlsx'); // initiate a file download in browser
  }

  generateLetter()  {
    console.log('Language: ', this.language);
    this.patient.case_manager = this.case_manager;
    if(this.language === 'English') {
      this.pdf.createLetter(this.program_id, this.program_name, this.patient, this.letter_type, this.letter_customtext, this.user).then(() => {
        this.language = null;
        this.letter_type = null;
        this.letter_customtext = null;
        this.custom_text = null;
        this.case_manager = this.user_fullname;
      })
      .catch(err => {
        this.utility.presentToast('There was an error generating the letter you request.  Please try again');
      });
    } else {
      console.log('Creating french letter');
      this.pdfFR.createLetter(this.program_id, this.program_name, this.patient, this.letter_type, this.letter_customtext, this.user).then(() => {
        this.language = null;
        this.letter_type = null;
        this.letter_customtext = null;
        this.custom_text = null;
        this.case_manager = this.user_fullname;
      })
      .catch(err => {
        this.utility.presentToast('There was an error generating the letter you request.  Please try again');
      });
    }
  }

  cancel()  {
    this.documentPanelStatus = false;
  }

  onDocUrl(ev)  {
   this.cancel();
  }

  viewDocument(row) {
    window.open(row.url, '_blank');
  }

  deleteDocument(row) {
  let confirm = this.alertCtrl.create({
    title: "Delete Document",
    message: "Are you sure you want to delete this document?  If so, type 'delete' into the textbox to confirm",
    inputs: [
      {
        name: 'delete_text',
        placeholder: 'delete',
        type: 'text'
      }
    ],
    buttons: [
      {
        text: "Cancel",
        handler: () => {
          // console.log("Don't update");
        }
      },
      {
        text: "Delete Document",
        handler: data => {
          let delete_text = data.delete_text;
          if(delete_text === 'delete') {
        
            this.dbPatient.deleteDocument(this.program_id, this.patient.id, row.id)
            .then(response => {
              console.log('Delete document id: ', row.id);
              const toast = this.toastCtrl.create({
                message:
                  "The document was successfully deleted.",
                duration: 3000
              });
              toast.present();
            })
            .catch(err => {
              const errortoast = this.toastCtrl.create({
                message:
                  "The document could not be deleted. Error: " + err,
                duration: 3000
              });
              errortoast.present();
            });
          } else {
            return;
          }
        }
      }
    ]
  });
  confirm.present();
  }

  sendFax(doc)  {
    const url = doc.url;
    let confirm = this.alertCtrl.create({
      title: "Send Fax",
      message: "Please enter the fax number",
      inputs: [
        {
          name: 'fax_number',
          placeholder: 'fax number',
          type: 'tel'
        }
      ],
      buttons: [
        {
          text: "Cancel",
          handler: () => {
            // console.log("Don't update");
          }
        },
        {
          text: "Send Fax",
          handler: data => {
            const loading = this.loadingCtrl.create({});
            loading.present().then(() => {

            let fax_number = data.fax_number;
            fax_number = fax_number.replace('-','').replace('(','').replace(')','').replace(/\s+/g,'').replace('+', '');
            if(fax_number.startsWith("1")) {
              fax_number = "+" + fax_number;
            } else {
              fax_number = "+1" + fax_number;
            }
            this.db.sendFax(data.fax_number, url).then(response => {
              loading.dismiss().then(() => {
                const toast = this.toastCtrl.create({
                  message:
                    "Fax was successfully sent. Your confirmation is: " + response['sid'],
                  duration: 3000
                });
                toast.present();
              });
            })
            .catch(err => {
              loading.dismiss().then(() => {
                const errortoast = this.toastCtrl.create({
                  message:
                    "The fax could not be sent at this time.  Please try again. Error: " + err,
                  duration: 3000
                });
                errortoast.present();
              });
            });

            });
          }
        }
      ]
    });
    confirm.present();
  }

  classifyDocument(doc) {
    this.chartDialogRef = this.matDialog.open(DocumentProcessDialogComponent, {
      hasBackdrop: true,
      disableClose: true,
      width: '400px',
      data: { program_id: this.program_id, patientv: true }
    });

    this.chartDialogRef
    .afterClosed()
    .takeUntil(this.ngUnsubscribe)
    .subscribe(result => {
      if(result) {
        const document = { ...result };
        document.id = doc.id;
        delete document.patient;
        delete document.enrolment_url;
        delete document.enrolmentURL;
        this.dbPatient.classifyDocument(this.program_id, this.patient.id, document, this.user)
        .then(() => {
          this.utility.presentToast('The document was succesfully classified.');
        })
        .catch(err => {
          this.utility.presentToast('There was a problem classifying this document.  Please try again.');
        });
     }
    });
  }

  customTextHint(event, showtext, hint)  {
    if(event.isUserInput) {
      console.log(event.source.value, event.source.selected);
      console.log('Change custom text: ', hint, showtext);
      this.custom_text_hint = hint;
      this.custom_text = showtext;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/patient-document/patient-document.ts